/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'components/Grid';
import { Form, Formik } from 'formik';
import {
  InputField,
  SelectField,
} from 'components/Form';
import {
  MobileLabel,
  FilterContainer,
  RowFilterIcon, LeftIcon, RightIcon,
  FilterSearchContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  ColIcon,
  FieldGrid,
  TooltipCard,
  TooltipText,
  TooltipBox,
} from './styles'
import { Button } from 'components';
import Icon from 'components/Icon';
import Checkbox from 'components/Form/CheckBox';
import { Label } from 'components/Form';
import { Text } from './styles';
import Colors from "constants/Colors";


const ListHeader = (props) => {
  const formik = useRef(null);

  const initialValues = {
    search: ''
  };

  const [showFilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAllDocs, setSelectedAllDocs] = useState(false);

  useEffect(() => {
    props.formikRef(formik)
  }, [])


  return (
    <Formik
      onSubmit={(values) => {
        props.updateFilter(values)
      }}
      initialValues={initialValues}
      innerRef={formik}
      enableReinitialization={true}

    >
      {(formikProps) => {

        return (
          <Form>

            <RowFilterIcon>
              <LeftIcon>
                <ColIcon>
                  <Label textColor={Colors.GRAY[0]}>
                    <Checkbox
                      checked={props.selectedAllDocsCheckBox}
                      onClick={() => {
                        props.setSelectedAllDocsCheckBox(!props.selectedAllDocsCheckBox)
                      }}
                    />
                  </Label>
                  <Text small style={{ color: '#fff' }}>Documents</Text>
                </ColIcon>
              </LeftIcon>

              <FilterContainer className={showModal ? 'filter-open' : 'filter-close'}>
                <Row style={{ paddingBottom: '15px' }}>
                  <Col style={{ display: "flex", justifyContent: 'flex-end' }}>
                    <Icon name="close" className="icon-close" onClick={() => setShowModal(false)} />
                  </Col>
                </Row>

                <FilterSearchContainer style={{ display: 'flex', flexFlow: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <Text small style={{ textTransform: 'none', marginBottom: '10px', textAlign: 'center' }}>Please, select an insurer to share the files.</Text>
                  <FilterColumn>
                    <FieldGrid
                      name="insurer"
                      placeholder="Insurer"
                      component={SelectField}
                      options={props.insurersList || []}
                      validation={false}
                      value={formikProps.values.insurer}
                      filter={true}
                      onChange={(e) => {
                        props.changeInsurerSelected(e);
                      }}
                      corDiferente={false}
                    />
                  </FilterColumn>
                </FilterSearchContainer>

                <Row align="center" className='apply-button-container'>
                  <Col>
                    <Button
                      primary
                      type="button"
                      id="btnFilter"
                      style={{ textAlign: "center" }}
                      onClick={(e) => {
                        setShowModal(false);
                        props.changeShowModalChat(!props.showChatModalState)
                      }}
                    >
                      Apply
                    </Button>
                  </Col>
                </Row>
              </FilterContainer>

              <RightIcon>

                <ColIcon>
                  <Icon
                    name="download-files-grey"
                    title="Download files selected"
                    onClick={() => props.handleDownloadSelectedFiles()}
                  />
                </ColIcon>

                {props.changeShowAttachments && (
                  <TooltipCard>
                    <TooltipText>
                      <ColIcon>
                        <Icon name="add-grey" style={{ cursor: 'pointer' }} onClick={() => props.changeShowAttachments(!props.showAttachmentsState)} />
                      </ColIcon>
                    </TooltipText>
                    <TooltipBox>
                      {props.iconTooltips[594]}
                    </TooltipBox>
                  </TooltipCard>
                )}

                <ColIcon>
                  <Icon
                    title="Share Files"
                    name="big-share-grey"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setShowModal(!showModal)
                    }} />
                </ColIcon>
              </RightIcon>

            </RowFilterIcon>
          </Form>
        )
      }}

    </Formik>
  )
}

export default ListHeader;
